import {
  ANINewsImg,
  AsianNewsImg,
  BharatScoopsImg,
  BigNewsImg,
  BizNews,
  BusinessStandardNewsImg,
  DailyHuntNewsImg,
  FinancialNewsDay,
  IndianBusinessLine,
  JioNewsImg,
  LatestLyNewsImg,
  MumbaiTimesImg,
  NewIndiaHerald,
  NewsImg,
  NewsTrendDaily,
  NewsWireIndia,
  Republic21,
  RepublicNewsTodayImg,
  RTNews24,
  SamacharSansaarImg,
  StartupReporterImg,
  TheIndianAlert,
  TheNewsCartelImg,
  ThePrintNewsImg,
  TribuneIndia,
  UNINewsImg,
  Up18NewsImg,
  VentureCompanyNews,
  WebIndia123Img,
  WorldNewsForAll,
} from "./ImagesS3";

const newsArticlesStaticData = [
  {
    id: 1,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "ANI",
    date: "August 15, 2024",
    image: ANINewsImg,
    url: "https://www.aninews.in/news/business/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model20240815160501/",
  },
  {
    id: 2,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "Business Standard",
    date: "August 15, 2024",
    image: BusinessStandardNewsImg,
    url: "https://www.business-standard.com/content/press-releases-ani/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model-124081500550_1.html",
  },
  {
    id: 3,
    title:
      "Bataiyo, India's First Zero-Commission Super App, Launches on January 26, 2025",
    category: "Information",
    source: "The Tribune",
    date: "January 26, 2025",
    image: TribuneIndia,
    url: "https://www.tribuneindia.com/news/business/bataiyo-indias-first-zero-commission-super-app-launches-on-january-26-2025/",
  },
  {
    id: 4,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "The Print",
    date: "August 15, 2024",
    image: ThePrintNewsImg,
    url: "https://theprint.in/ani-press-releases/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/2224826/",
  },
  {
    id: 5,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Lokmat Times",
    date: "August 15, 2024",
    image: NewsImg,
    url: "https://www.lokmattimes.com/business/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 6,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "LATESTLY",
    date: "August 15, 2024",
    image: LatestLyNewsImg,
    url: "https://www.latestly.com/agency-news/business-news-bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model-6191744.html",
  },
  {
    id: 7,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "United News of India",
    date: "August 15, 2024",
    image: UNINewsImg,
    url: "https://www.uniindia.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-45-commission-model/pnn/news/3262992.html",
  },
  {
    id: 8,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Web India 123",
    date: "August 15, 2024",
    image: WebIndia123Img,
    url: "https://news.webindia123.com/news/articles/Business/20240815/4225430.html",
  },
  {
    id: 9,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Big News",
    date: "August 15, 2024",
    image: BigNewsImg,
    url: "https://www.bignewsnetwork.com/news/274494408/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model",
  },
  {
    id: 10,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Daily Hunt",
    date: "August 15, 2024",
    image: DailyHuntNewsImg,
    url: "https://m.dailyhunt.in/news/india/english/ani+english-epaper-anieng/bataiyo+registration+begins+this+independence+day+revolutionizing+digital+connections+with+a+zerocommission+model-newsid-n626705519?sm=Y",
  },
  {
    id: 11,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Jio News",
    date: "August 15, 2024",
    image: JioNewsImg,
    url: "https://www.latestly.com/agency-news/business-news-bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model-6191744.html?utm_source=JioNews&utm_medium=referral&utm_campaign=JioNews",
  },
  {
    id: 12,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "Asian News",
    date: "August 15, 2024",
    image: AsianNewsImg,
    url: "https://asiannews.in/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 13,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "UP 18 News",
    date: "August 15, 2024",
    image: Up18NewsImg,
    url: "https://up18news.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 14,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Samachar Sansaar News",
    date: "August 15, 2024",
    image: SamacharSansaarImg,
    url: "https://en.samacharsansaar.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 15,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "Republic News Today",
    date: "August 15, 2024",
    image: RepublicNewsTodayImg,
    url: "https://republicnewstoday.com/index.php/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/?__cf_chl_rt_tk=sB5s0QwWGdhIXg_Ky8FC2m0H9fjcG7snTKGRrHsuHsc-1758525500-1.0.1.1-9VH5i6KA5c.o9pCzgAEHKYId8g7LqtV28zcRRJWV6Vc",
  },
  {
    id: 16,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "The News Cartel",
    date: "August 15, 2024",
    image: TheNewsCartelImg,
    url: "https://thenewscartel.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 17,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "Startup Reporter",
    date: "August 15, 2024",
    image: StartupReporterImg,
    url: "https://startupreporter.in/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 18,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "The Indian Alert",
    date: "August 15, 2024",
    image: TheIndianAlert,
    url: "https://theindianalert.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 19,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Mumbai Times",
    date: "August 15, 2024",
    image: MumbaiTimesImg,
    url: "https://mumbaitimes.online/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 20,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Information",
    source: "Bharat Scoops",
    date: "August 15, 2024",
    image: BharatScoopsImg,
    url: "https://bharatscoops.com/technology/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 21,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "Financial News Day",
    date: "August 15, 2024",
    image: FinancialNewsDay,
    url: "https://financialnewsday.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 22,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "News Trend Daily",
    date: "August 15, 2024",
    image: NewsTrendDaily,
    url: "https://newstrenddaily.com/index.php/2024/8/15/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 23,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Business",
    source: "News Wire India",
    date: "August 15, 2024",
    image: NewsWireIndia,
    url: "https://newswireindia.in/index.php/2024/8/15/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 24,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "Real Time News 24",
    date: "August 15, 2024",
    image: RTNews24,
    url: "https://rtnews24.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 25,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "Biz News",
    date: "August 15, 2024",
    image: BizNews,
    url: "https://biznewss.in/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 26,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "Venture Company News",
    date: "August 15, 2024",
    image: VentureCompanyNews,
    url: "https://venturecompanynews.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 27,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "World News For All",
    date: "August 15, 2024",
    image: WorldNewsForAll,
    url: "https://worldnewsforall.com/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 28,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "Indian BusinessLine",
    date: "August 15, 2024",
    image: IndianBusinessLine,
    url: "https://indianbusinessline.com/index.php/2024/8/15/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 29,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "New India Herald",
    date: "August 15, 2024",
    image: NewIndiaHerald,
    url: "https://newindiaherald.com/index.php/2024/8/15/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
  {
    id: 30,
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    category: "Technology",
    source: "republic 21",
    date: "August 15, 2024",
    image: Republic21,
    url: "https://republic21.in/index.php/2024/08/15/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
  },
];

export default newsArticlesStaticData;
